// ADO-3257 (story D-2): whether a cart state names a send made after a view of the cart. The web's
// copy of Enabler E8-G (ADO-3109) DA-1's test, which the server makes for cards 10 and 11
// (`isViewOfASentCart`, `libs/modules/order-capture/src/domain/submission.ts`): a view of the cart
// at a revision at or before its latest send's, of a cart now past that send. A send recorded
// without emptying the cart leaves the cart at the send's revision, so a view of it is of the
// cart as it is. By revision, never by clock.

import type { BasketState } from '../api/basket.client';

/** The cart a page showed, and the revision it showed it at. */
export interface SeenCart {
  readonly cartId: string;
  readonly revision: number;
}

/** When the cart `state` is was last sent, if that was after `seen`; otherwise `null` (no view,
 *  a view of another cart, no send named, or a send at or before the view). */
export function sentSinceSeen(seen: SeenCart | null, state: BasketState): string | null {
  const sent = state.latestSend;
  if (seen === null || sent === undefined || sent === null) return null;
  if (state.cartId === null || state.cartId !== seen.cartId) return null;
  return seen.revision <= sent.revision && sent.revision < state.revision ? sent.sentAt : null;
}
